import { useAuth } from "./useMsAuth";


export const msalPlugin = {
    install: (app, options) => {
        const { userState, initAuth } = useAuth();
        if (!userState.isAuthenticated) {
            initAuth();
        }

    }
};